/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Implant from './implant';
import ImplantDetail from './implant-detail';
import ImplantUpdate from './implant-update';
import ImplantDeleteDialog from './implant-delete-dialog';

const ImplantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Implant />} />
    <Route path="new" element={<ImplantUpdate />} />
    <Route path=":id">
      <Route index element={<ImplantDetail />} />
      <Route path="edit" element={<ImplantUpdate />} />
      <Route path="delete" element={<ImplantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImplantRoutes;
